<div class="blog-area pt-4 pb-4">
    <div class="container-fluid px-md-3 px-2">
        <div class="row g-3 blog-card-container">
            <!-- Blog Cards -->
            <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let blog of blogs">
                <div class="single-blog-post-box cursor-pointer new-card-design" (click)="viewblog(blog)">
                    <div class="card-content-wrapper">
                        <div class="image-container">
                            <div class="post-image">
                                <a class="d-block">
                                    <img [src]="blog?.picture ? fileBaseUrl + blog.picture : 'assets/fv/fv_placeholder.jpeg'" [alt]="blog.title">
                                </a>
                            </div>
                        </div>
                        <div class="post-content">
                            <a (click)="redirectToBlog(blog.category)" class="category">{{blog.category}}</a>
                            <h3 class="blog-title">{{blog.title}}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pagination -->
            <div class="col-lg-12 col-md-12" *ngIf="totalPages > 1">
                <div class="pagination-area text-center">
                    <a (click)="onPageChange(currentPage - 1)" class="prev page-numbers"
                       [class.disabled]="currentPage === 1">
                        <i class='bx bx-chevrons-left'></i>
                    </a>
                    <a *ngFor="let page of [].constructor(totalPages); let i = index"
                       (click)="onPageChange(i + 1)"
                       [class.current]="currentPage === (i + 1)"
                       class="page-numbers">
                        {{i + 1}}
                    </a>
                    <a (click)="onPageChange(currentPage + 1)" class="next page-numbers"
                       [class.disabled]="currentPage === totalPages">
                        <i class='bx bx-chevrons-right'></i>
                    </a>
                </div>
            </div>

            <!-- No Results Message -->
            <div class="col-12" *ngIf="blogs.length === 0">
                <div class="alert alert-info text-center">
                    No blogs found. Try adjusting your search.
                </div>
            </div>
        </div>
    </div>
</div>